'use strict';

export const Constants = Object.freeze({
  CONFIRM_MODAL_HEADER_TEXT: 'Are you sure?',
  EMPTY_CRMID_ERROR_TEXT: 'CRM ID cannot be empty.',
  EMPTY_ASANAID_ERROR_TEXT: 'ASANA ID cannot be empty.',
});
